/**
 * Wait until a DOM selector matches or timeout.
 * @param {string} selector
 * @param {number} [timeoutMs=4000]
 * @returns {Promise<boolean>}
 */
export function waitForSelector(selector, timeoutMs = 4000) {
  if (typeof document === 'undefined') return Promise.resolve(false);
  if (document.querySelector(selector)) return Promise.resolve(true);

  return new Promise((resolve) => {
    const start = Date.now();
    const interval = setInterval(() => {
      if (document.querySelector(selector)) {
        clearInterval(interval);
        resolve(true);
      } else if (Date.now() - start >= timeoutMs) {
        clearInterval(interval);
        resolve(false);
      }
    }, 100);
  });
}
